import React from 'react'
import { Outlet } from "react-router-dom";
import Navbar from './NavbarComponents/Navbar'
import FooterPage from './FooterComponents/FooterPage'

export default function MainLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <FooterPage />
    </>
  )
}